import React from 'react';
import { motion } from 'framer-motion';

import { useGetParams } from '../../hooks/useGetParams';
import { WordAnimator } from '../WordAnimator/WordAnimator';

import styles from './Advt.module.css';

import logo from '../../assets/images/logo.png';

const Advt = React.memo(({ prevState }) => {
  const { qrCode1, qrCode2 } = useGetParams();

  const initDelay = !prevState ? 0 : 1;

  return (
    <div className={styles.wrapper}>
      <motion.img
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5, delay: initDelay }}
        src={logo}
        alt=""
        className={styles.logo}
      />
      <div className={styles.title}>
        <WordAnimator
          text={'Присылайте'}
          initDelay={initDelay}
          isRepeat={false}
          duration={0.5}
        />
        <WordAnimator
          text={'свой'}
          initDelay={0.3 + initDelay}
          isRepeat={false}
          duration={0.5}
        />
        <WordAnimator
          text={'вариант'}
          initDelay={0.6 + initDelay}
          isRepeat={false}
          duration={0.5}
        />
      </div>

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.5 + initDelay }}
            className={styles.qrCode}
          >
            <img src={qrCode1} alt="" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.75 + initDelay }}
            className={styles.qrCode}
          >
            <img src={qrCode2} alt="" />
          </motion.div>
        )}
      </div>
    </div>
  );
});

export default Advt;
